"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";
export default function Testimonials() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const testimonials = [{
    quote: "Working with this team transformed our business. Their attention to detail and commitment to excellence is unmatched.",
    author: "Sarah Mitchell",
    role: "CEO, TechVentures"
  }, {
    quote: "The results exceeded our expectations. Professional, responsive, and truly dedicated to our success.",
    author: "James Rodriguez",
    role: "Founder, CreativeHub"
  }, {
    quote: "An exceptional experience from start to finish. They understood our vision and brought it to life perfectly.",
    author: "Emily Chen",
    role: "Director, Innovation Labs"
  }];
  return <section id="testimonials" className="bg-background py-24 px-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground md:text-5xl">
            What Our Clients Say
          </h2>
          <p className="text-muted mt-4 text-lg">
            Trusted by businesses worldwide
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div ref={card1Ref} data-index={0} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${card1Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
          transitionDelay: "0ms"
        }}>
            <Card className="card group h-full border border-border shadow-soft hover:shadow-medium">
              <CardContent className="flex h-full flex-col">
                <Quote className="text-accent-dark mb-6 h-10 w-10 transition-all duration-[var(--duration-medium)] group-hover:scale-110" />
                <p className="text-foreground mb-6 flex-grow text-base leading-relaxed">
                  {testimonials[0].quote}
                </p>
                <div>
                  <p className="font-display text-foreground text-lg font-semibold">
                    {testimonials[0].author}
                  </p>
                  <p className="text-muted text-sm">
                    {testimonials[0].role}
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div ref={card2Ref} data-index={1} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${card2Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
          transitionDelay: "150ms"
        }}>
            <Card className="card group h-full border border-border shadow-soft hover:shadow-medium">
              <CardContent className="flex h-full flex-col">
                <Quote className="text-accent-dark mb-6 h-10 w-10 transition-all duration-[var(--duration-medium)] group-hover:scale-110" />
                <p className="text-foreground mb-6 flex-grow text-base leading-relaxed">
                  {testimonials[1].quote}
                </p>
                <div>
                  <p className="font-display text-foreground text-lg font-semibold">
                    {testimonials[1].author}
                  </p>
                  <p className="text-muted text-sm">
                    {testimonials[1].role}
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div ref={card3Ref} data-index={2} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${card3Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
          transitionDelay: "300ms"
        }}>
            <Card className="card group h-full border border-border shadow-soft hover:shadow-medium">
              <CardContent className="flex h-full flex-col">
                <Quote className="text-accent-dark mb-6 h-10 w-10 transition-all duration-[var(--duration-medium)] group-hover:scale-110" />
                <p className="text-foreground mb-6 flex-grow text-base leading-relaxed">
                  {testimonials[2].quote}
                </p>
                <div>
                  <p className="font-display text-foreground text-lg font-semibold">
                    {testimonials[2].author}
                  </p>
                  <p className="text-muted text-sm">
                    {testimonials[2].role}
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}